import { EditProductProps } from "../constants/enum"
import { IEditBusinessInfoFormProps, useEditBusinessInfo } from "../hooks/useEditBusinessInfo";
import { useParams } from "react-router";
import { useForm } from "react-hook-form";
import { useGetCorporation } from "../hooks/useGetCorporation";
import { EditBusinessInfoInput, EditBusinessInfoMutation, GetCorporationInput } from "../generated/graphql";
import { GetCorporationQuery } from "../generated/graphql";
import { useEffect } from "react";
import { FormError2 } from "../components/form-error";
import { Button } from "../components/button";
import { useDaumPostcodePopup } from "react-daum-postcode";

export const AdminUpBusinessInfo:React.FC<EditProductProps> = ({
    tabs,
    setTabHandler,
}) => {
    const params = useParams();

    const {
        register,
        handleSubmit,
        getValues,
        setValue,
        setFocus,
        watch,
        control,
        formState: { errors, isValid },
    } = useForm<IEditBusinessInfoFormProps>({ mode: "all" });
    
    const onGetComplete = (data: GetCorporationQuery) => {
        const {
            getCorporation: { ok, err, corporation },
        } = data;
        if (!ok) {
            alert("잘못된 접근입니다.");
            window.location.href = "/business";
            return;
        }
        setValue("businessName", corporation?.businessName || "");
        setValue("businessNumber", corporation?.businessNumber || "");
        setValue("ceoName", corporation?.ceoName || "");
        setValue("businessAddress", corporation?.businessAddress || "");
      
    }
    const [getCorporation, { data, loading }] = useGetCorporation(onGetComplete);
    const getCorporationHandler = (corporationId: number) => {
      const getCorporationInput: GetCorporationInput = {
        corporationId,
      };
      getCorporation({ variables: { input: getCorporationInput } });
    };

    const onUpComplete = (data: EditBusinessInfoMutation) => {
        const {
            editBusinessInfo: { ok, err },
        } = data;
        if (ok) {
            alert("저장되었습니다.");
            window.location.href = "/corporation";
        } else {
            alert(err);
        }
    }
    const [editBusinessInfo, { loading: editBusinessInfoLoading }] = useEditBusinessInfo(onUpComplete);
    const onSubmit = () => {
        if (!params.corporationId) return;
        if (!editBusinessInfoLoading) {
            const { businessName, businessNumber, businessAddress, ceoName } = getValues();
            const editBusinessInfoInput: EditBusinessInfoInput = {
                businessName,
                businessNumber,
                businessAddress,
                ceoName,
                corporationId: +params.corporationId,
            };
            editBusinessInfo({ variables: { input: editBusinessInfoInput } });
        }
    }
    const handlePostCode = (data: any) => {
        console.log(data);
        let fullAddress = data.address;
        let extraAddress = "";
        if (data.addressType === "R") {
          if (data.bname !== "") {
            extraAddress += data.bname;
          }
          if (data.buildingName !== "") {
            extraAddress +=
              extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
          }
          fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
          
          setValue(`businessAddress`, fullAddress);
          setFocus(`businessAddress`);
        }else if(data.addressType === "J") {
            if (data.bname !== "") {
                extraAddress += data.bname;
              }
              fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
              setValue(`businessAddress`, fullAddress);
              setFocus(`businessAddress`);
        }
      };
    const scriptUrl =
    "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
  const open = useDaumPostcodePopup(scriptUrl);
    const handlerClick = () => {
        open({ onComplete: handlePostCode });
      };

    useEffect(() => {
        if (!params.corporationId) return;
        const corporationId = +params.corporationId;
        getCorporationHandler(corporationId);
    }, []);

    return (
        <div className="shadow-lg h-[800px] h-fix-content w-full overflow-auto bg-white">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="pl-9 pr-11 py-8 space-y-4">
                    <div className="space-y-2">
                        <p className="font-bold text-[#4F4F4F] text-base">
                            사업자명
                        </p>
                        <input
                            {...register("businessName", {
                                required: `사업자명을 입력해주세요`,
                            })}
                            type="text"
                            className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                        />
                        {errors.businessName?.message && (
                            <FormError2 errorMessage={errors.businessName.message} />
                        )}
                    </div>
                    <div className="space-y-2">
                        <p className="font-bold text-[#4F4F4F] text-base">
                            대표자명
                        </p>
                        <input
                            {...register("ceoName", {
                                required: `대표자명을 입력해주세요`,
                            })}
                            type="text"
                            className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                        />
                    </div>
                    <div className="space-y-2">
                        <p className="font-bold text-[#4F4F4F] text-base">
                            사업자 등록번호
                        </p>
                        <input
                            {...register("businessNumber", {
                                required: `사업자 등록번호를 입력해주세요`,
                            })}
                            type="text"
                            className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                        />
                        {errors.businessNumber?.message && (
                            <FormError2 errorMessage={errors.businessNumber.message} />
                        )}
                    </div>
                    <div className="space-y-2">
                        <p className="font-bold text-[#4F4F4F] text-base">
                            <span className="pr-4">사업자 주소</span>
                            <button
                      className="bg-white py-1 px-4 border border-btnDarkLine rounded-lg text-btn text-grayFont"
                      type="button"
                      onClick={handlerClick}
                    >
                      우편번호찾기
                    </button>
                        </p>
                        <input
                            {...register("businessAddress", {
                                required: `사업자 주소를 입력해주세요`,
                            })}
                            type="text"
                            className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                        />
                        {errors.businessAddress?.message && (
                            <FormError2 errorMessage={errors.businessAddress.message} />
                        )}
                    </div>
                    <div className="flex flex-wrap justify-center pt-6">
                        <Button
                        className={`w-[240px] h-[40px] bg-[#3D3E49] text-white rounded-lg`}
                        canClick={true}
                        actionText={`등록`}
                        loading={loading}
                        color={"text-white"}
                        />
                    </div>
                </div>
            </form>
        </div>
    )
}